import React from 'react';

const ROOMUNLOCKEDTheme = {
  headerLogo: {
    src: '/themes/theme/theroom/Room_Unlocked_logo.png',
    alt: 'TheRoom influencers',
  },
  darkLogo: {
    src: '/themes/theme/theroom/Room_Unlocked_logo.png',
    alt: 'TheRoom influencers',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #002a5a',
  },
  linkStyle: {
    color: '#002a5a',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'THE ROOM | CAMPAIGNS',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <img height="50" src="/themes/theme/theroom/Room_Unlocked_logo.png" alt="TheRoom Influencers" />
    </div>
  ),
  shareSite: 'https://reports.roomunlocked.com',
  organisationId: '5bf5b36b-48cb-4d2a-a304-580db89965f9',
};

export default ROOMUNLOCKEDTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/roomunlocked.js
 **/